// Language selector (EN/FR/ES) for the sidebar user panel (i18n).
// Mirrors the ThemeToggle persistence model: the choice is stored in
// localStorage (`bandz.locale`) and re-applied on load by src/i18n/index.ts.
// The default language is ENGLISH; FR/ES prepare the ground for the Phase 2
// translation of the hardcoded UI strings.

import { useTranslation } from 'react-i18next';
import { setAppLanguage } from '../i18n';

const LANGS: Array<{ code: 'en' | 'fr' | 'es'; label: string; titleKey: string }> = [
  { code: 'en', label: 'EN', titleKey: 'language.english' },
  { code: 'fr', label: 'FR', titleKey: 'language.french' },
  { code: 'es', label: 'ES', titleKey: 'language.spanish' },
];

export default function LanguageSelector() {
  const { i18n, t } = useTranslation();
  const raw = (i18n.language || 'en').toLowerCase();
  const current = raw.startsWith('es') ? 'es' : raw.startsWith('fr') ? 'fr' : 'en';

  function onChange(e: React.ChangeEvent<HTMLSelectElement>) {
    setAppLanguage(e.target.value as 'en' | 'fr' | 'es');
  }

  return (
    <select
      className="logout-btn language-toggle-btn"
      value={current}
      onChange={onChange}
      title={t('language.label')}
      aria-label={t('language.label')}
      style={{ flex: 1, minWidth: 0, cursor: 'pointer' }}
    >
      {LANGS.map((l) => (
        <option key={l.code} value={l.code}>
          🌐 {l.label}
        </option>
      ))}
    </select>
  );
}
